import React, { useEffect } from 'react'
import { styles } from '../../../../styles/tailwind-config'
import useNav from '../../../../hooks/useNav'
import { Label } from '../../../../components/ui/label'
import QastanLogo from '../../../../assets/logo/qastan-logo.svg'

const Main = () => {
    const { setNav, nav } = useNav()
    useEffect(()=>{
        setNav({...nav, title:'Meer info'})
    }, [])

  return (
    <div className='p-4 flex flex-col gap-4'>
        <h1 className={styles.h1}>Meer info</h1>
        <img className='w-20 h-20' src={QastanLogo} alt="Qastan logo" />
        <div>
            <p className='font-semibold'>Een probleem?</p>
            <p>Neem contact op met:</p>
            <div className='flex items-center gap-1'><p>Telefoon:</p><a href="tel:+3251310744" className='underline text-primary'>+32 51 31 07 44</a></div>
            <div className='flex items-center gap-1'><p>E-mail:</p><a href="mailto:helpdesk@qastan.be" className='underline text-primary'>helpdesk@qastan.be</a></div>
        </div>
    </div>
  )
}

export default Main